module.exports = __webpack_public_path__ + "img/store-light.23d577a1.png";